module.exports = __webpack_public_path__ + "static/img/logo-c.3a6693ff.png";